import OrderTotalConnector from './orderTotal.props';
import OrderTotalComponent from './orderTotal.component';

export default OrderTotalConnector(OrderTotalComponent);
